import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';
import * as colors from 'commons/styles/colors';

class PickSummaryPageStyle extends CommonComponentStyle {
  HeaderWrapper = styled.div`
    padding: 8px 0;
    text-align: center;
  `;

  Header = styled.p<{ color?: string }>`
    font-size: 18px;
    font-weight: 700;
    display: inline-flex;
    margin-bottom: 0;
    color: ${(props): string => props.color || colors.PRIMARY_GREEN};
  `;

  SubHeader = styled.p`
    margin-top: 0;
  `;

  SKUSummaryWrapper = styled.div`
    padding: 8px 0;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 16px;
  `;

  SummaryName = styled.p`
    font-size: 14px !important;
    margin: 8px;
  `;

  SummaryValue = styled.p`
    font-size: 14px !important;
    font-weight: 700 !important;
    text-align: right !important;
    margin: 8px;
  `;

  PriorityText = styled.div`
    font-size: 20px !important;
    font-weight: 700 !important;
    margin: 16px 0;
  `;
}

export default new PickSummaryPageStyle();
